// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"e9cb51f9","168":"d374ed84","702":"b83d9778","806":"ce5bf4f3","914":"402f5bc6"}[chunkId] + ".chunk.js";
};